import { CloseOutlined } from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useAiAnswerView } from 'store/main_book_popup/selectors';
import styled from "styled-components";
import COLOR from 'utils/constants/color';
import {Mic, VideocamSharp} from '@mui/icons-material';
import FillBlanksPreview from 'features/forms/assignment/fillInBlanks/fillBlanksPreview';
import { MatchMakingPreview } from 'features/forms/assignment';
import { useLocation } from 'react-router-dom'; 
import usePopUpAtOnce from './hooks/usePopUpAtOnce';
import useStoryViewOpen from './hooks/useStoryViewOpen';


const HEADER_HEIGHT = 90;
const FOOTER_HEIGHT = 90;

const OuterWrapper = styled.div`
    position: absolute;
    top:  ${(p) => p.pathname?.includes("ebook") ? "7px" : "-6px"};
    z-index: ${(p) => p.pathname?.includes("ebook") ? "66" : "9999"};
    width:98%;
    height:100%;
    overflow: visible;

    @media screen and (max-width: 900px){
      top: 12px;
    }
    @media screen and (max-width: 600px){
      top: 20px;
    }
    @media screen and (max-width: 520px){
      top: 6px;
      width: 96% !important;
    }
`;

const Wrapper = styled.div`
    width:100%;
    height:100%;
    background-color: ${COLOR.white};
    box-shadow: 7px -3px 26px 20px rgb(66 66 66), -4px -3px 26px 15px rgb(95 109 110);
    display: flex;
    flex-direction: column;

    @media screen and (max-width: 600px){
      overflow-y: scroll;
    }
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #2d8bba;
    padding: 0 60px;
    height: ${HEADER_HEIGHT}px;
    flex-shrink: 0;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
    background: #fff;
    @media screen and (max-width: 600px){
     padding: 0px;
     min-height: 200px;
    }
    min-height: 100px;
`;

const QuestionsContainer = styled.div`
    flex: 1;
    overflow-y: auto;
`;

const Footer = styled.footer`
    background-color: #2d8bba;
    color: #fff;
    text-align: center;
    padding: 10px 10px;
    height: auto;
    margin-top: auto;
    flex-shrink: 0;

     @media screen and (max-width: 816px){
        font-size: 12px;
    }
     @media screen and (max-width: 606px){
        padding: 10px 10px;
    }    
    @media screen and (max-width: 520px){
        font-size: 10px;
    }
    @media screen and (max-width: 355px){
        height:auto;
    }   
`;

const AnswerForm = ({ questions, isExam, isUnitExam, isAiAnswer,  isGeneratedTest }) => {

    const activityHeadingLabel = isUnitExam
    ? 'EXAMEN DE UNIDAD'
    : isExam
      ? 'PRUEBA'
      : isGeneratedTest
        ? 'ACTIVIDAD GENERADA'
        : 'ACTIVIDAD';

    return (<>
    <Content>
        <Header>
                <div position="relative">
                    <p style={{ color: '#fff', fontSize: '20px', lineHeight: '30px', margin: '0px' }}>One Way Education</p>
                    <img
                    src="https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/assets%2Fbird.png?alt=media&token=6a9a7f5a-4959-431c-a305-8eabe60a4d46"
                    alt="Bird"
                    style={{ height: '100px', width: 'auto', position: 'absolute', left: '-20px', top: '0px' }}
                    />
                </div>
            </Header>
            <div style={{ color: '#800059', marginLeft: '40px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                <p style={{ fontWeight: 'bolder', fontSize: '25px', margin: "0px" }}>{activityHeadingLabel}</p>
                {isAiAnswer && (
                    <p style={{ fontSize: '16px', margin: "0px 60px 0px 0px", color:"#000" }}>RESPUESTAS</p>
                )}
            </div>
        <QuestionsContainer>
        {questions?.map((qus, index) => {
            const options = qus.options || [];
            const correctAnswerIndex = parseInt(qus.answer, 10);
            return (
                <div key={index} style={{ marginTop: '20px', backgroundColor: 'white', padding: '0px 10px' }}>
                    <h3 style={{ color: '#1a1a1a', marginBottom: '5px', fontWeight: '600', fontSize: 20, display: 'flex', alignItems: 'flex-start' }}>
                        <span style={{ marginRight: '10px' }}>{`${index + 1}.`}</span>
                        <span style={{ flex: 1 }} dangerouslySetInnerHTML={{ __html: qus.question || '' }}></span>
                        {(qus.type === 'audio' || qus.type === 'twoMinAudio') && <Mic />}
                        {qus.type === 'video' && <VideocamSharp />}
                    </h3>
                    {(qus.type === 'multipleChoice' || qus.type === 'trueFalse' || qus.type == 'audioTrueFalse' || qus.type === 'multipleResponse') && (
                        <ul style={{ lineHeight: 1.6, color: '#333', marginTop: '5px', marginLeft: 20, listStyleType: 'none' }}>
                            {options.map((option, i) => (
                                <li key={i} style={{ color: i === correctAnswerIndex ? '#D08BAB' : '#4a4a4a', fontSize: 16 }}>
                                    {`${String.fromCharCode(97 + i)}) ${option}`}
                                </li>
                            ))}
                        </ul>
                    )}
                    {(qus.type === 'essay' || qus.type === 'email') && (
                        <div style={{ lineHeight: 1.6, color: '#333', marginTop: '5px', marginLeft: 20 }}>
                            <p style={{ color: '#D08BAB' }}>{qus?.answer_text ? qus?.answer_text : qus?.expected_answer}</p>
                        </div>
                    )}
                    {qus.type === 'picture' && (
                        <img src={qus?.pictures} alt="Question Image" style={{ height: '200px', width: '170px' }} />
                    )}
                    {(qus.type === 'filling' || qus.type === 'fillingImage') && (
                        <div>
                            {options.map((option, i) => (
                                <>
                                    <FillBlanksPreview
                                        fromAnswer={true}
                                        text={option}
                                        highlights={qus?.highlightWords && qus.highlightWords[i] || []}
                                        selected_answer={qus.highlightWords && qus?.highlightWords[i]}
                                        isAssignmentReview={true}
                                    />
                                    {qus.type === 'fillingImage' && (
                                        <>
                                            <img
                                                alt={`filling ${i}`}
                                                src={qus?.filling_image && qus?.filling_image[i]?.url}
                                                draggable={false}
                                                style={{
                                                    width: "100px",
                                                    height: "100px",
                                                    borderRadius: "8px",
                                                    marginTop: "10px",
                                                    cursor: "pointer"
                                                }}
                                            />
                                        </>
                                    )}
                                </>
                            ))}
                        </div>
                    )}
                    {qus.type === 'match' && (
                        <MatchMakingPreview isAiAnsewr={true} question={qus} />
                    )}
                </div>
            );
        })}
        </QuestionsContainer>
        <Footer>
            <p>©One Way Education. All rights reserved. Reproduction of this work, whether total or partial, by any means or procedure, including reprography and computer processing, photocopying, or recording, is prohibited without prior written authorization of the rights holder.</p>
        </Footer>
    </Content>
    </>)
}

export default function AssignableNotificationAnswer({ getRef }) {
    const { aiAnswerView, revokeAiAnswerView } = useAiAnswerView()
    const [questions, setQuestions] = useState("")
    const containerRef = getRef()
    const [style, setStyle] = useState({ height: 0, width: 0 })
    const backBtnRef = useRef();
    const forwardBtnRef = useRef();
    const imageRef = useRef();
    const location = useLocation();
    const {updatePopUpAtOnce} = usePopUpAtOnce();
    const isStoryViewOpen = useStoryViewOpen();
    const [isExam, setIsExam] = useState(false)
    const [isUnitExam, setIsUnitExam] = useState(false)
    const [isGeneratedTest, setIsGeneratedTest] = useState(false)
    const [isAiAnswer, setIsAiAnswer] = useState(false)

    useEffect(() => {
        if (aiAnswerView.open) {
            setQuestions(aiAnswerView.questions?.questions)
            setIsExam(aiAnswerView.questions?.is_exam)
            setIsUnitExam(aiAnswerView.questions?.is_unit_exam)
            setIsGeneratedTest(aiAnswerView.questions?.generated_test)
            setIsAiAnswer(aiAnswerView.questions?.is_ai)
        } else {
            setQuestions([])
        }
    }, [aiAnswerView])

    useEffect(() => {
        handleClose();
    }, [location.pathname]); 

    useEffect(() => {
        function updateStyle() {
            if (containerRef) {
                const { width, height } = containerRef.getBoundingClientRect()
                setStyle({ height, width })
            }
        }

        updateStyle();
        window.addEventListener('resize', updateStyle);

        return () => {
            window.removeEventListener('resize', updateStyle);
        }
    }, [aiAnswerView])

    useEffect(() => {
        document.addEventListener('keydown', checkKey);
        return () => {
            document.removeEventListener("keydown", () => { })
        }
    }, [])

    const handleClose = () => {
        revokeAiAnswerView();
        if (!isStoryViewOpen()) updatePopUpAtOnce(false);
    };

    function checkKey(e) {
        let isMainBook = document.getElementsByClassName("main-book-popup printScreenPage").length > 0;
        if (isMainBook) {
            e = e || window.event;
            if (e.keyCode == '37') {
                if (backBtnRef.current && !backBtnRef.current.disabled) {
                    backBtnRef.current.click()
                }
            }
            else if (e.keyCode == '39') {
                if (forwardBtnRef.current && !forwardBtnRef.current.disabled) {
                    forwardBtnRef.current.click()
                }
            }
        }
    }

    if (!aiAnswerView.open) return null;

    return (
        <OuterWrapper
             className='asignAbleSecUpr '
             pathname={location.pathname}
        >
            <CloseOutlined onClick={handleClose} style={{
                position: 'absolute',
                top: '-10px',
                right: '-10px',
                cursor: 'pointer',
                fontSize: '16px',
                color: 'white',
                background: 'red',
                padding: '5px',
                borderRadius: '50%',
                zIndex: 10001
            }} />
            <Wrapper>
            
            <AnswerForm questions={questions || []} isExam={isExam} isUnitExam={isUnitExam} isAiAnswer={isAiAnswer} isGeneratedTest={isGeneratedTest} />
            
            </Wrapper>
        </OuterWrapper>
    );
}
